module.exports = __webpack_public_path__ + "787537895920e584f2b12541aebe5479.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person_different_team_2x.png
// module id = 38
// module chunks = 0 1 2 3 4